import React from 'react';
import clsx from 'clsx';
import Filter from '@/components/Filter';
import { states } from '@/constants/lifecycle';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const NotificationsFilters = ({
  category,
  className,
  code,
  event,
  fluid,
}) => {
  const { filterTerm, readStatus } = Selectors.useNotificationsFilters({ category, code, event });
  const fetchData = Events.useFetchNotifications(category, { code });
  const updateFilterTerm = Events.useUpdateNotificationsFilter(category, { code });

  return (
    <Filter
      error={readStatus === states.ERROR}
      fluid={fluid}
      className={clsx('aridhia-notifications-filter', className)}
      filterTerm={filterTerm || ''}
      updateFilter={({ value }) => updateFilterTerm({ event, value })}
      onFilter={() => fetchData({ event, page: 1 })}
    />
  );
};

export default NotificationsFilters;
